import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { UserService } from '../_services/user-service/user.service';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class HttpCustomInterceptor implements HttpInterceptor {

  constructor(private userService: UserService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      withCredentials: true,
    });

    const token = this.userService.getAuthToken();
    if(token) {
      request = request.clone({
        setHeaders: {
          "Authorization": `Basic ${token}`
        }
      });
    }

    console.debug(request);
    return next.handle(request)
  }
}
